import { render, staticRenderFns } from "./QuoteCarousel.vue?vue&type=template&id=939fa6b8&scoped=true"
import script from "./QuoteCarousel.vue?vue&type=script&lang=js"
export * from "./QuoteCarousel.vue?vue&type=script&lang=js"
import style0 from "./QuoteCarousel.vue?vue&type=style&index=0&id=939fa6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939fa6b8",
  null
  
)

export default component.exports